import { type Item } from '@/features/cart/types'
import { algoliaGlobalFilter } from '@/services/algolia'

export const buildFilters = (itemGroups: Item[][]) => {
  const groupFilters = itemGroups.map((items) => {
    const excludedProductIds = items
      .map((item) => `NOT id:${item.productId}`)
      .join(' AND ')
    return `(${excludedProductIds})`
  })

  const combinedFilter = groupFilters.join(' OR ')
  return `(${combinedFilter}) AND ${algoliaGlobalFilter}`
}
